
export const theme_ns: ThemeNS = 'eften2025';
